<lsl-order-control [formControl]="form" [strings]="strings" [(reset)]="_reset"></lsl-order-control>
